if (!customElements.get('custom-slider')) {
  class CustomSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = new Swiper(this.querySelector('.js-custom-slider'), {
        slidesPerView: this.dataset.slidesMobile || 2,
        centeredSlides: this.dataset.centeredSlidesMobile || false,
        centeredSlidesBounds: true,
        breakpoints: {
          991: {
            slidesPerView: this.dataset.slidesDesktop || 5,
            centeredSlides: this.dataset.centeredSlidesDesktop || false,
          }
        },
        on: {
          init: () => {
            this.classList.add('loaded')
          }
        },
        navigation: {
          enabled: true,
          nextEl: this.querySelector('.js-slide-next'),
          prevEl: this.querySelector('.js-slide-prev')
        },
        pagination: {
          enabled: true,
          clickable: true,
          el: this.querySelector('.js-pagination')
        }
      });
    }
  }
  
  customElements.define('custom-slider', CustomSlider);
}

